module.exports = __webpack_public_path__ + "static/media/lds-logo_sk.4d5a4523.svg";